<template>
    <span v-if="price !== null"> {{ price | toEuro }}</span>
</template>
<script>
export default {
    props: {
        price: {
            type: Number,
            required: false
        }
    }
};
</script>
